module.exports = __webpack_public_path__ + "de91a035013d19ce524d2d4f0409809c.glb";